import React, { useEffect, useState } from "react";
import { Accordion, Col, Container, Row } from "react-bootstrap";

// css
import styles from "./faq.module.scss";
import { GET_FAQS } from "../../../../services/ApiCalls";
import { toast } from "react-toastify";

const Faq = () => {
  const [faq, setFaqs] = useState();
  const getData = async () => {
    try {
      const res = await GET_FAQS();
      if (res?.data?.status === "success") {
        setFaqs(res?.data?.data);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      <section className={`${styles.faq} faq py-2 position-relative`}>
        <Container>
          <Row className="justify-content-center">
            <Col lg="12" className="my-2">
              <div className="sectionHeader mb-3">
                <h3 className="m-0 fw-sbold themeBlue">FAQ</h3>
              </div>
            </Col>
            <Col lg="10" className="my-2">
              <Accordion defaultActiveKey="0">
                {faq?.map((fq, key) => {
                  return (
                    <Accordion.Item
                      className={`${styles.AccordionWrp} my-lg-3 my-2 p-lg-4`}
                      eventKey={key}
                    >
                      <Accordion.Header className="position-relative">
                        {fq.question}
                        <span
                          className={`${styles.icn} icn position-absolute d-flex align-items-center justify-content-center rounded-circle`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="9"
                            height="15"
                            viewBox="0 0 9 15"
                            fill="none"
                          >
                            <path
                              d="M1.01831 14.1918L7.45796 7.72288L1.01831 1.25399"
                              stroke="#4A3AFF"
                              stroke-width="1.56696"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </Accordion.Header>
                      <Accordion.Body className="py-0">
                        <Row>
                          <Col lg="11" className="my-2">
                            <div
                              dangerouslySetInnerHTML={{ __html: fq?.answer }}
                            ></div>
                          </Col>
                        </Row>
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Faq;
